PrivateBoardInfo = require('common/components/create-board/private-board-info').default
{ ldclient } = require 'common/lib/ldclient'
PopOver = require 'views/lib/pop-over'
React = require 'react'
t = require('views/internal/recup-with-helpers')('board_list_item_add')
Util = require 'lib/util'
localizeCount = require 'lib/localize-count'

module.exports = class extends React.Component
  displayName: 'BoardListItemPrivateBoard'
  constructor: (props) ->
    super props

    @questionRef = React.createRef()
    @textRef = React.createRef()

    @hidePopOver = @hidePopOver.bind(@)
    @handleOnMouseEnter = @handleOnMouseEnter.bind(@)
    @handleOnMouseLeave = @handleOnMouseLeave.bind(@)

  handleOnMouseEnter: (currentRef) => (e) =>
    { org } = @props
    @setState({ isActive: true })
    limit = org.getFreeBoardLimit()

    if currentRef
      @setState({ currentRef })
    else
      currentRef = @state.currentRef

    textComponent = React.createElement PrivateBoardInfo,
      key: 1
      isAtOrOverLimit: org.isAtOrOverFreeBoardLimit(),
      openBoardCount: limit.count,
      orgName: org.get('displayName'),
      upgradeUrl: org.getBillingUrl(),
      onMouseEnter: @handleOnMouseEnter(currentRef),
      onMouseLeave: @handleOnMouseLeave,

    PopOver.show
      elem: currentRef.current
      maxWidth: '242'
      hideHeader: true
      reactElement: textComponent

  handleOnMouseLeave: ->
    @setState({
      isActive: false
    })
    setTimeout((@hidePopOver), 500)

  hidePopOver: ->
    if !@state.isActive
      PopOver.hide()

  render: t.renderable ->
    t.li '.boards-page-board-section-list-item.board-limits-private-board-list-item', =>
      t.div '.board-tile.private-mod', =>
        t.div '.lock-icon', =>
          t.icon 'private'
        t.div '.private-board-text', =>
          t.format 'private-board'
        t.div '.question-icon', {
          onMouseEnter: @handleOnMouseEnter(@questionRef),
          onMouseLeave: @handleOnMouseLeave,
          ref: @questionRef
        }, =>
          t.icon 'help'




// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-item-private-board-component.coffee